import { MenuItem, Stack, TextField } from '@mui/material';

import { useDebouncedBlockContent } from '@/hooks/use-debounced-block-content';
import type { ImageBlockContent } from '@/types/database';

const OBJECT_FIT_OPTIONS: ImageBlockContent['objectFit'][] = ['cover', 'contain'];

export function ImageBlockEditPanel({
  content,
  onUpdate,
}: {
  content: ImageBlockContent;
  onUpdate: (content: ImageBlockContent) => void;
}) {
  const [draft, update] = useDebouncedBlockContent(content || { imageUrl: '' }, onUpdate);

  return (
    <Stack spacing={1.5}>
      <TextField
        label="Image URL"
        value={draft.imageUrl || ''}
        onChange={(event) => update({ ...draft, imageUrl: event.target.value })}
        fullWidth
      />
      <TextField
        label="Caption"
        value={draft.caption || ''}
        onChange={(event) => update({ ...draft, caption: event.target.value })}
        fullWidth
      />
      <TextField
        label="Alt Text"
        value={draft.alt || ''}
        onChange={(event) => update({ ...draft, alt: event.target.value })}
        fullWidth
      />
      <TextField
        select
        label="Fit"
        value={draft.objectFit ?? 'cover'}
        onChange={(event) => update({ ...draft, objectFit: event.target.value as ImageBlockContent['objectFit'] }, { immediate: true })}
        fullWidth
      >
        {OBJECT_FIT_OPTIONS.map((option) => (
          <MenuItem key={option} value={option}>{option}</MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
